import React from "react";
import { motion } from "framer-motion";
import { User, Mail, Lock, Chrome, UserPlus } from "lucide-react";

const Signup = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F7FA] px-4">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="bg-white shadow-xl rounded-2xl p-8 w-full max-w-md border-t-4 border-[#004182]"
      >
        {/* Header */}
        <h2 className="text-3xl font-bold text-[#004182] mb-2 text-center">
          Create Account
        </h2>
        <p className="text-gray-500 text-center mb-6">
          Join{" "}
          <span className="text-[#F3A712] font-semibold">Tiranga Express</span>{" "}
          and experience fast, secure logistics.
        </p>

        {/* Form */}
        <form className="space-y-4">
          <div>
            <label className="block text-gray-700 mb-1">Full Name</label>
            <div className="flex items-center border border-gray-300 rounded-md px-3">
              <User className="text-gray-500 mr-2" size={18} />
              <input
                type="text"
                placeholder="Enter your full name"
                className="w-full py-2 outline-none"
              />
            </div>
          </div>

          <div>
            <label className="block text-gray-700 mb-1">Email Address</label>
            <div className="flex items-center border border-gray-300 rounded-md px-3">
              <Mail className="text-gray-500 mr-2" size={18} />
              <input
                type="email"
                placeholder="Enter your email"
                className="w-full py-2 outline-none"
              />
            </div>
          </div>

          <div>
            <label className="block text-gray-700 mb-1">Password</label>
            <div className="flex items-center border border-gray-300 rounded-md px-3">
              <Lock className="text-gray-500 mr-2" size={18} />
              <input
                type="password"
                placeholder="Create a password"
                className="w-full py-2 outline-none"
              />
            </div>
          </div>

          <button
            type="submit"
            className="w-full flex justify-center items-center gap-2 bg-[#004182] hover:bg-[#003466] text-white py-2 rounded-md font-medium transition"
          >
            <UserPlus size={18} /> Sign Up
          </button>
        </form>

        {/* Divider */}
        <div className="my-6 flex items-center">
          <div className="flex-1 border-t border-gray-300"></div>
          <span className="mx-3 text-gray-400 text-sm">or</span>
          <div className="flex-1 border-t border-gray-300"></div>
        </div>

        {/* Google Signup */}
        <button className="w-full flex justify-center items-center gap-3 border border-gray-300 py-2 rounded-md hover:bg-gray-100 transition">
          <Chrome className="text-[#DB4437]" size={20} />
          <span className="text-gray-700 font-medium">Sign up with Google</span>
        </button>

        {/* Footer */}
        <p className="text-center text-sm text-gray-600 mt-6">
          Already have an account?{" "}
          <a
            href="/login"
            className="text-[#F3A712] font-semibold hover:underline"
          >
            Log in
          </a>
        </p>
      </motion.div>
    </div>
  );
};

export default Signup;
